import { FC } from 'react';

import { Formik, FormikConfig } from 'formik';
import { DraggableFileUploader } from 'ui/components/form';

import {
  UPLOAD_ATTACHMENTS_SCHEMA,
  UPLOAD_ATTACHMENTS_FORM,
} from '../forms/schema';
import { useCreateMultipleAttachments } from '../hooks';

type PROPS = {
  referenceId: string;
  source?:
    | 'Comment'
    | 'Lead'
    | 'Company'
    | 'Task'
    | 'OrderInvoice'
    | 'Deal'
    | 'AICaller';
  sizePerFileLimit?: {
    size: number;
    message: string;
  };
  removeFileSizeLimit?: boolean;
  onSubmit?: (val: UPLOAD_ATTACHMENTS_FORM) => void;
  singleFile?: boolean;
  disabledSave?: boolean;
};

const FORM_INIT: UPLOAD_ATTACHMENTS_FORM = {
  files: [],
};

const UploadAttachmentsModal: FC<PROPS> = ({
  source = 'Lead',
  sizePerFileLimit = {
    size: 1024 * 1024 * 10, // 10MB
    message: 'One of your files is larger than 10MB',
  },
  removeFileSizeLimit = false,
  referenceId,
  onSubmit: _onSubmit,
  singleFile,
  disabledSave,
}) => {
  const { mutate: createMultipleAttachments } = useCreateMultipleAttachments({
    referenceId,
  });
  const onSubmit: FormikConfig<UPLOAD_ATTACHMENTS_FORM>['onSubmit'] = async (
    values,
    { setSubmitting },
  ) => {
    _onSubmit
      ? _onSubmit?.(values)
      : createMultipleAttachments(values.files, {
          onSettled: () => {
            setSubmitting(false);
          },
        });
  };

  return (
    <Formik
      validationSchema={UPLOAD_ATTACHMENTS_SCHEMA}
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
    >
      {() => (
        <DraggableFileUploader
          source={source}
          referenceId={referenceId}
          sizePerFileLimit={sizePerFileLimit}
          removeFileSizeLimit={removeFileSizeLimit}
          singleFile={singleFile}
          disabled={disabledSave}
        />
      )}
    </Formik>
  );
};

export default UploadAttachmentsModal;
